import styled from 'styled-components';
import { Typography } from '../../../../stories/atoms';
import { RowFlexContainer } from '../../../../stories/atoms/containerV2/ContainerV2';
import { ThemeMode } from '../../../../global-state/themeContext';
import { muiTheme, percentToHex } from '../../../../theme';
import { TrendEnum } from '../../../../constants/budgetPlanned';

const getBackgroundColor = (status: TrendEnum, mode: ThemeMode) => {
  if (status === TrendEnum.UP) {
    return muiTheme.color.successLightTransparent;
  } else {
    return mode === 'dark' ? percentToHex(muiTheme.color.red, 16) : percentToHex(muiTheme.color.error, 24);
  }
};

const getTextColor = (status: TrendEnum, mode: ThemeMode) => {
  if (status === TrendEnum.UP) {
    return mode === 'dark' ? muiTheme.color.success : muiTheme.color.validationGreen;
  } else {
    return mode === 'dark' ? muiTheme.color.error : muiTheme.color.red;
  }
};

export const LWLYBadgeContainer = styled(RowFlexContainer)<{ status: TrendEnum }>`
  background-color: ${({ theme: { palette }, status }) => getBackgroundColor(status, palette.mode)};
  border: ${({ theme: { palette }, status }) =>
    palette.mode === 'dark'
      ? `1px solid ${status === TrendEnum.UP ? muiTheme.color.successLight : muiTheme.color.error}`
      : 'none'};
`;

export const LWLYBadgeText = styled(Typography)<{ status: TrendEnum }>`
  color: ${({ theme: { palette }, status }) => getTextColor(status, palette.mode)} !important;
`;
